import styled from 'styled-components';

const FilterBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: #F2FAFF;
    margin: ${props => props.margin || 0}
`;

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/FilterBar.js